import { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, useMemo } from 'react';

import DiscountSuite from './components/discountSuite';
import { MainCard, MoreChannelWrapper } from './style';

import { selectPackagePromotion } from '@/apis/activity';
import GroupItem from '@/components/ProductItem/groupItem';
import MainItem from '@/components/ProductItem/mainItem';
import OldBatchItem from '@/components/ProductItem/oldBatchItem';
import OverseasItem from '@/components/ProductItem/overseasItem';
import ProductSpuItem from '@/components/ProductItem/ProductSpuItem';
import SecondKillItem from '@/components/ProductItem/secondKillItem';
import { ProductItemProvider } from '@/providers/productItem';
import { ProductListContext } from '@/providers/productList';
import { buriedPoint } from '@/utils/buriedPoint';
import Utils from '@/utils/Utils';

const ProductItem = forwardRef((props, ref) => {
  const {
    productVO,
    isGroupProduct,
    isSecondKill,
    moreChannelVO,
    osCoupon,
    spm,
    dataCustomData,
    index,
    productSpuMap,
    productConnectorMap,
    dhAndTeAndRoCoupon,
  } = props;
  const [showMoreChannel, setShowMoreChannel] = useState(false);
  const [showDiscountSuite, setShowDiscountSuite] = useState(false);
  const [showProductSpuMap, setShowProductSpuMap] = useState(false);
  const [showProductConnectorMap, setShowProductConnectorMap] = useState(false);
  const [promotionList, setPromotionList] = useState([]);
  const { searchResult } = useContext(ProductListContext);
  const [moreChannel, setMoreChannel] = useState([]);
  const [isFixed, setIsFixed] = useState(false);
  const [btnLeft, setBtnLeft] = useState(0);

  const closeBtnRef = useRef(null);
  const moreListRef = useRef(null);
  const productItemRef = useRef(null);
  const scrollTopBeforeOpen = useRef(0);

  useImperativeHandle(ref, () => ({
    checkButtonPosition,
  }));

  useEffect(() => {
    let list = moreChannelVO || [];
    // 开始处理数据，当更多渠道里面存在（阶梯价格（第一个）、起订量、拆分比例、供应商）四个字段的值和对应商品的字段值一致的话，过滤掉该数据
    if (productVO?.selfProductCode && moreChannelVO?.length > 0) {
      const { lcBookProductVO } = productVO;
      list = moreChannelVO?.filter(
        (item) =>
          item.theRatio !== productVO?.theRatio ||
          item.minBuyNumber !== productVO?.minBuyNumber ||
          item.provider !== lcBookProductVO?.provider ||
          item?.tieredPrices?.[0]?.price !== productVO?.productPriceList?.[0]?.thePrice
      );
    }
    setMoreChannel(list);
  }, [productVO, searchResult, moreChannelVO]);

  useEffect(() => {
    if (showMoreChannel) {
      scrollTopBeforeOpen.current = window.pageYOffset || document.documentElement.scrollTop;
      checkButtonPosition();
    } else if (scrollTopBeforeOpen.current && !showMoreChannel) {
      window.scrollTo(0, scrollTopBeforeOpen.current);
    }
  }, [showMoreChannel]);
  function handleShowMoreChannel(value) {
    setShowMoreChannel(value);
    if (value) {
      buriedPoint({
        op: 'More_channels',
        data: {
          pc: productVO?.productCode,
          ix: index,
          no: moreChannelVO?.length,
          kw: searchResult?.globalSearchKeyword,
          cp: searchResult?.currePage,
        },
      });
      buriedPoint({
        op: 'view',
        ty: 'enter',
        data: {
          type: moreChannelVO?.map((item) => item?.provider).join(),
          ix: moreChannelVO?.map((_, index) => index).join(),
        },
      });
      handleCloseOtherBtn({
        runShowMoreChannel: false,
      });
    }
  }

  function handleShowDiscountSuite(value) {
    if (value && promotionList.length === 0) {
      selectPackagePromotion({ productId: productVO?.productId }).then((res) => {
        if (res?.needLogin || res?.msg === 'needLogin') {
          Utils.showWindowLogin();
        } else if (res?.code === 200 && res?.result) {
          setPromotionList(res?.result);
          setShowDiscountSuite(value);
        }
      });
    } else {
      setShowDiscountSuite(value);
    }
    if (value) {
      handleCloseOtherBtn({
        runShowDiscountSuite: false,
      });
    }
  }

  function handleShowProductSpuMap(value, location) {
    setShowProductSpuMap(value);
    if (value) {
      buriedPoint({
        op: 'same_series',
        data: {
          pc: productVO?.productCode,
          ix: index,
          no: productSpuMap?.length,
          kw: searchResult?.globalSearchKeyword,
          cp: searchResult?.currePage,
          location,
        },
      });
      handleCloseOtherBtn({
        runShowProductSpuMap: false,
      });
    }
  }

  function handleShowProductConnectorMap(value) {
    setShowProductConnectorMap(value);
    if (value) {
      buriedPoint({
        op: 'connector',
        data: {
          pc: productVO?.productCode,
          ix: index,
          no: productConnectorMap?.productList?.length,
          kw: searchResult?.globalSearchKeyword,
          cp: searchResult?.currePage,
        },
      });
      handleCloseOtherBtn({
        runShowProductConnectorMap: false,
      });
    }
  }

  // 关闭其他按钮
  const handleCloseOtherBtn = ({
    runShowMoreChannel = true,
    runShowDiscountSuite = true,
    runShowProductSpuMap = true,
    runShowProductConnectorMap = true,
  }) => {
    runShowMoreChannel && setShowMoreChannel(false);
    runShowDiscountSuite && setShowDiscountSuite(false);
    runShowProductSpuMap && setShowProductSpuMap(false);
    runShowProductConnectorMap && setShowProductConnectorMap(false);
  };

  // 检查关闭按钮位置
  function checkButtonPosition() {
    if (!showMoreChannel && !showProductSpuMap && !showProductConnectorMap) {
      setIsFixed(false);
      return;
    }
    if (closeBtnRef?.current && moreListRef?.current) {
      const btnRect = closeBtnRef.current.getBoundingClientRect();
      const ListRect = moreListRef.current.getBoundingClientRect();
      setIsFixed(ListRect.top + 38 < window.innerHeight && btnRect.bottom > window.innerHeight);
      setBtnLeft(ListRect.left);
    }
  }

  const CloseBtn = ({ isFixedButton, closeBtnRef, onClickClose = null }) => {
    const productItemRect = productItemRef.current?.getBoundingClientRect();
    return (
      <div
        ref={closeBtnRef}
        className={`py-[10px] text-center ${isFixedButton ? 'fixed bottom-0 rounded-b-[10px] bg-[#fff]' : 'bg-[#f3f9fd]'} left-[${btnLeft}px] cursor-pointer`}
        style={{ width: `${productItemRect?.width}px` }}
        onClick={() => {
          typeof onClickClose === 'function' ? onClickClose() : handleShowMoreChannel(false);
        }}
      >
        <span className="text-[#1FA0E8]">
          <span className="mr-[7px]">点击收起</span>
          <span className="mb-[-2px] ml-[px] inline-block size-[7px] rotate-[45deg] border-l-[1px] border-t-[1px] border-solid border-[#0294e8]"></span>
        </span>
      </div>
    );
  };

  // 老批次直接挂到sku
  const oldBathOnSku = useMemo(() => {
    if (!isGroupProduct && !isSecondKill && productVO?.oldBatchProductList?.length > 0) {
      return true;
    }
    return false;
  }, [isGroupProduct, isSecondKill, productVO?.oldBatchProductList]);

  return (
    <ProductItemProvider {...props}>
      <div
        ref={productItemRef}
        data-spm={spm}
        data-custom-data={dataCustomData}
        className={`overflow-hidden rounded-[10px] hover:shadow-[0_1px_8px_2px_rgba(0,0,0,0.08)] ${index === 0 ? 'rounded-t-[0]' : ''}`}
      >
        <MainCard data-spm="zy">
          <MainItem
            {...props}
            showMoreBtn={productVO?.oldBatchProductList?.length - (oldBathOnSku ? 1 : 0) > 0 || moreChannel?.length > 0}
            showMoreChannel={showMoreChannel}
            onShowMoreChannel={handleShowMoreChannel}
            showDiscountSuite={showDiscountSuite}
            onShowDiscountSuite={handleShowDiscountSuite}
            showProductSpuMapBtn={productSpuMap?.length > 0}
            showProductSpuMap={showProductSpuMap}
            onShowProductSpuMap={handleShowProductSpuMap}
            showProductConnectorMapBtn={productConnectorMap?.productList?.length > 0}
            showProductConnectorMap={showProductConnectorMap}
            onShowProductConnectorMap={handleShowProductConnectorMap}
          />
        </MainCard>
        {(isGroupProduct || isSecondKill) && (
          <MoreChannelWrapper>
            {isGroupProduct && (
              <div className="more-channel-item" data-spm="lt">
                <GroupItem {...props} />
              </div>
            )}
            {isSecondKill && (
              <div className="more-channel-item" data-spm="ms">
                <SecondKillItem {...props} />
              </div>
            )}
          </MoreChannelWrapper>
        )}
        {oldBathOnSku && (
          <MoreChannelWrapper>
            <div className="more-channel-item" data-spm={`lpc1`} key={productVO?.oldBatchProductList[0]?.productCode}>
              <OldBatchItem index={index} {...props} oldBatchProductVO={productVO?.oldBatchProductList[0]} />
            </div>
          </MoreChannelWrapper>
        )}
        {(productVO?.oldBatchProductList?.length - (oldBathOnSku ? 1 : 0) > 0 || moreChannel?.length > 0) &&
          showMoreChannel && (
            <MoreChannelWrapper
              ref={moreListRef}
              className={`${showMoreChannel ? 'display' : 'hidden'} border-t-[1px] border-solid border-[#efefef]`}
            >
              {productVO?.oldBatchProductList?.slice(oldBathOnSku ? 1 : 0)?.map((item, index) => (
                <div className="more-channel-item" data-spm={`lpc${index + 1}`} key={item?.productCode}>
                  <OldBatchItem index={index} {...props} oldBatchProductVO={item} />
                </div>
              ))}
              {moreChannel?.map((more, index) => (
                <div className="more-channel-item" data-spm={`m${index + 1}`} key={index}>
                  <OverseasItem
                    productVO={more}
                    index={index}
                    showCopy={false}
                    osCoupon={osCoupon}
                    isMore={true}
                    totalStockNumber={props?.totalStockNumber}
                    dhAndTeAndRoCoupon={dhAndTeAndRoCoupon}
                  />
                </div>
              ))}
              <CloseBtn closeBtnRef={closeBtnRef}></CloseBtn>
              {isFixed && <CloseBtn isFixedButton={true}></CloseBtn>}
            </MoreChannelWrapper>
          )}
        {promotionList?.length > 0 && (
          <div className={`${showDiscountSuite ? 'display' : 'hidden'}`}>
            <DiscountSuite promotionList={promotionList} />
          </div>
        )}
        {productSpuMap?.length > 0 && showProductSpuMap && (
          <MoreChannelWrapper
            ref={moreListRef}
            className={`${showProductSpuMap ? 'display' : 'hidden'} bg-[#F3F9FD] rounded-b-[10px]`}
          >
            {productSpuMap?.map((productSpuItem, productSpuIndex) => {
              return (
                <div key={productSpuIndex}>
                  <div className={'text-[14px] text-[#000000] font-bold px-[20px] pt-[20px]'}>
                    {productSpuItem?.spuTypeText}
                  </div>
                  {productSpuItem?.productExpandInfoList?.map((spuItem, spuIndex) => {
                    return (
                      <div key={spuIndex} data-spm={`xl${spuIndex + 1}`}>
                        <ProductSpuItem
                          {...spuItem}
                          showBorder
                          needBold={true}
                          showTag={true}
                          suggest={'same_series'}
                        ></ProductSpuItem>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            <CloseBtn
              closeBtnRef={closeBtnRef}
              onClickClose={() => {
                handleShowProductSpuMap(false);
              }}
            ></CloseBtn>
            {isFixed && (
              <CloseBtn
                isFixedButton={true}
                onClickClose={() => {
                  handleShowProductSpuMap(false);
                }}
              ></CloseBtn>
            )}
          </MoreChannelWrapper>
        )}
        {productConnectorMap && showProductConnectorMap && (
          <MoreChannelWrapper
            ref={moreListRef}
            className={`${showProductConnectorMap ? 'display' : 'hidden'}  bg-[#F3F9FD] rounded-b-[10px]`}
          >
            <div className={'px-[20px] pt-[20px]'}>
              <div className={'text-[14px] text-[#000000] font-bold mb-[6px]'}>
                {productConnectorMap?.connectorConfigName || '-'}
              </div>
              <div className={'text-[12px] text-[#666666]'}>
                <span>配套用量：</span>
                <span>{productConnectorMap?.systemCompose}</span>
              </div>
            </div>
            {productConnectorMap?.productList?.map((connectItem, connectItemIndex) => {
              if (!connectItem?.productExpandInfoVO) return <></>;
              return (
                <div key={connectItemIndex} data-spm={`lj${connectItemIndex + 1}`} className={'relative'}>
                  <ProductSpuItem
                    {...connectItem?.productExpandInfoVO}
                    sideTitle={connectItem?.connectorConfigDetailName}
                    showBorder
                    showTag={false}
                    suggest={'connector'}
                  ></ProductSpuItem>
                </div>
              );
            })}
            <CloseBtn
              closeBtnRef={closeBtnRef}
              onClickClose={() => {
                handleShowProductConnectorMap(false);
              }}
            ></CloseBtn>
            {isFixed && (
              <CloseBtn
                isFixedButton={true}
                onClickClose={() => {
                  handleShowProductConnectorMap(false);
                }}
              ></CloseBtn>
            )}
          </MoreChannelWrapper>
        )}
      </div>
    </ProductItemProvider>
  );
});

ProductItem.displayName = 'ProductItem';

export default ProductItem;
